export default __webpack_public_path__ + "static/media/640_dummy2016-mode01-de-mobile.17149139.png";